import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/components/organism/Filter/types';
import { OPTIONS_CONST } from '@/src/constants/options';

export const pushAlarmInfoListFilters: (
  pushAlarmContentCategoryOptions: { label: string; value: string }[],
) => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = pushCategoryTypeOptions => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
  },
  {
    key: 'pushAlarmTitle',
    label: '제목',
    placeholder: '제목을 입력해주세요',
  },
  {
    key: 'pushProgressStatus',
    type: ListFilterTypeObject.SELECT,
    label: '발송 상태',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      {
        label: OPTIONS_CONST.pushScheduled,
        value: 'scheduled',
      },
      {
        label: OPTIONS_CONST.pushInProgress,
        value: 'inProgress',
      },
      {
        label: OPTIONS_CONST.pushCompleted,
        value: 'completed',
      },
    ],
  },
  {
    key: 'reservationTimeAt',
    label: '발송 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['reservationTimeStartedAt', 'reservationTimeEndedAt'],
  },
  {
    key: 'pushAlarmContent',
    label: '내용',
    placeholder: '내용을 입력해주세요',
  },
  {
    key: 'administratorName',
    label: '등록 관리자',
    placeholder: '담당 관리자를 입력해주세요',
  },
  {
    key: 'pushCategoryType',
    type: ListFilterTypeObject.SELECT,
    label: '카테고리',
    placeholder: '전체',
    options: pushCategoryTypeOptions,
  },
];
